import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { GuestGuard } from "src/auth/guard";
import SplashScreen from "src/components/splash-screen";
import AuthClassicLayout from "src/layouts/auth/classic";

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import("src/pages/auth/login-page"));

// ----------------------------------------------------------------------

const authPages = {
	path: "",
	element: (
		<GuestGuard>
			<Suspense fallback={<SplashScreen />}>
				<Outlet />
			</Suspense>
		</GuestGuard>
	),
	children: [
		{
			path: "login",
			element: (
				<AuthClassicLayout>
					<LoginPage />
				</AuthClassicLayout>
			),
		},
	],
};

export const authRoutes = [
	{
		path: "auth",
		children: [authPages],
	},
];
